import { render, staticRenderFns } from "./TariffEntityDetails.vue?vue&type=template&id=2717645d&scoped=true"
import script from "./TariffEntityDetails.vue?vue&type=script&lang=js"
export * from "./TariffEntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717645d",
  null
  
)

export default component.exports